import { FC, useState } from 'react';
import { Stack, Text, Button, Flex, Avatar } from '@chakra-ui/react';

interface AttendeesCellProps {
  attendees?: string[];
}

export const AttendeesCell: FC<AttendeesCellProps> = ({ attendees }) => {
  const [expanded, setExpanded] = useState(false);

  if (!Array.isArray(attendees) || attendees.length === 0) {
    return <Text fontSize="sm">-</Text>;
  }

  const visible = expanded ? attendees : attendees.slice(0, 1);

  return (
    <Stack spacing={1}>
      <Stack spacing={1}>
        {visible.map((email) => (
          <Flex key={email} align="center">
            <Avatar size="xs" name={email} />
            <Text
              ml={2}
              fontSize="sm"
              fontFamily="heading"
              color="text.secondary"
              fontWeight="medium"
              noOfLines={1}
            >
              {email}
            </Text>
          </Flex>
        ))}
      </Stack>

      {attendees.length > 1 && (
        <Flex>
          <Button
            variant="link"
            size="sm"
            color="primary"
            fontWeight="medium"
            w="fit-content"
            p={0}
            h="auto"
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? 'Show less' : `Show ${attendees.length - 1} more`}
          </Button>
        </Flex>
      )}
    </Stack>
  );
};
